// import React, { useState } from "react";
// import PropTypes from "prop-types";
// import { makeStyles } from "@material-ui/core";
// import NavBar from "./NavBar";
// import TopBar from "./TopBar";

// const useStyles = makeStyles((theme) => ({
//   root: {
//     display: "flex",
//     height: "100%",
//     overflow: "hidden",
//     width: "100%",
//   },
//   wrapper: {
//     display: "flex",
//     flex: "1 1 auto",
//     overflow: "hidden",
//     paddingTop: 70,
//     [theme.breakpoints.up("lg")]: {
//       paddingLeft: 256,
//     },
//     "@media (max-width:767px)": {
//       paddingTop: "70px !important",
//     },
//   },
//   contentContainer: {
//     display: "flex",
//     flex: "1 1 auto",
//     overflow: "hidden",
//   },
//   content: {
//     flex: "1 1 auto",
//     height: "100%",
//     overflow: "hidden",
//     position: "relative",
//     padding: "30px 25px 25px ",
//     [theme.breakpoints.down("sm")]: {
//       padding: "10px 10px 10px ",
//     },
//   },
// }));

// const DashboardLayout = ({ children }) => {
//   const classes = useStyles();
//   const [isMobileNavOpen, setMobileNavOpen] = useState(false);

//   return (
//     <div className={classes.root} style={{ backgroundColor: "white", height: "950px" }}>
//       <TopBar onMobileNavOpen={() => setMobileNavOpen(true)} />
//       <NavBar
//         onMobileClose={() => setMobileNavOpen(false)}
//         openMobile={isMobileNavOpen}
//       />
//       <div className={classes.wrapper}>
//         <div className={classes.contentContainer}>
//           <div className="yellowShade"></div>
//           <div className="blueShade"></div>
//           <div className={classes.content} id="main-scroll"  >
//             {children}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// DashboardLayout.propTypes = {
//   children: PropTypes.node,
// };

// export default DashboardLayout;



import React, { useState } from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core";
import NavBar from "./NavBar";
import TopBar from "./TopBar";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    height: "100%",
    overflow: "hidden",
    width: "100%",
  },
  wrapper: {
    display: "flex",
    flex: "1 1 auto",
    overflow: "hidden",
    paddingTop: 70,
    [theme.breakpoints.up("lg")]: {
      paddingLeft: 256,
    },
    "@media (max-width:767px)": {
      paddingTop: "70px !important",
    },
  },
  contentContainer: {
    display: "flex",
    flex: "1 1 auto",
    overflow: "hidden",
  },
  content: {
    flex: "1 1 auto",
    height: "100%",
    overflow: "hidden",
    position: "relative",
    padding: "30px 25px 25px ",
    [theme.breakpoints.down("sm")]: {
      padding: "10px 10px 10px ",
    },
  },
}));

const DashboardLayout = ({ children }) => {
  const classes = useStyles();
  const [isMobileNavOpen, setMobileNavOpen] = useState(false);

  return (
    <div className={classes.root} style={{ backgroundColor: "white" }}>
      <TopBar onMobileNavOpen={() => setMobileNavOpen(true)} />
      <NavBar
        onMobileClose={() => setMobileNavOpen(false)}
        openMobile={isMobileNavOpen}
      />
      <div className={classes.wrapper}>
        <div className={classes.contentContainer}>
          <div className="yellowShade"></div>
          <div className="blueShade"></div>
          <div className={classes.content} id="main-scroll">
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};

DashboardLayout.propTypes = {
  children: PropTypes.node,
};

export default DashboardLayout;
